/* eslint-disable react/no-array-index-key */
import React from 'react';
import Helmet from 'react-helmet';
import { useBreakpoints } from '@ux/responsive';
import { Container } from '@uds/grid';
import { Colorway } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';

import Tier from './DesktopTier';
import { Link } from './Tiers';
import { getClassNames } from './Desktop.stylesheet';

interface OuterProps {
  id: string;
  links: Array<Link>;
  colorway: Colorway;
  selected: number;
  layout: Layout;
}

export const PureDesktopTiers = ({ id: ribbonId, links, colorway, layout, selected }: OuterProps) => {
  const breakpoints = useBreakpoints();
  const classNames = getClassNames({ breakpoints, colorway, layout });

  return (
    <div>
      <Helmet />
      <Container>
        <nav className={classNames.tiers}>
          {links.map((link, i) => (
            <div key={`Tier_desktop_${ribbonId}_${i}`} className={classNames.link}>
              <Tier
                colorway={colorway}
                selected={i === selected}
                ribbonId={ribbonId}
                {...link}
              />
            </div>
          ))}
        </nav>
      </Container>
    </div>
  );
};

PureDesktopTiers.displayName = 'DesktopTiers';

export default PureDesktopTiers;
